import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AboutSection() {
    const { t } = useTranslation();
    return (

        <section className="relative py-[40px]">
            <div className="main-title">{t("Who Us")}</div>
            <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                <div
                    className="relative"
                >
                    <img
                        src={require("../../assets/image/2.jpg")}
                        alt="OMA Craftsmanship"
                        className="w-full h-[450px] object-cover rounded-2xl shadow-2xl parallax-image"
                    />
                    <div className="d-none absolute -bottom-6 -right-6 w-40 h-40 bg-[#b58630] rounded-full opacity-30 animate-pulse"></div>
                </div>
                <div
                    className="flex flex-col justify-center"
                >
                    <h3 className="text-4xl md:text-5xl font-extrabold text-[#b58630] mb-8 typing">
                        {t("Art Meets Precision")}
                        <span className="cursor">|</span>
                    </h3>
                    <p className="text-gray-700 text-xl mb-8">
                        {t("At OMA, every pair is a masterpiece, blending Japanese craftsmanship with cutting-edge optical technology.")}
                    </p>
                    <Link
                        to="/about-us"
                        className="w-fit bg-[#b58630] text-white py-4 px-8 rounded-full font-bold text-lg hover:bg-[#a57729] hover:scale-105 transition-all glow"
                    >
                        {t("Our Story")}
                    </Link>
                </div>
            </div>
        </section>
    );
}